import React from "react";
import { useTranslation } from "react-i18next";

//Style
import "./InfoInfraestructureSection.css";

const InfoInfraestructureSection = ({ info }) => {
  const { t } = useTranslation();

  return (
    <section className="info-infra-section">
      <div className="title-container">
        <span className="deco-title"></span>
        <h1 className="infra-title">
          {t("infraestructure_page.info_section.title")}
        </h1>
        <img
          style={{ width: "2.5rem" }}
          className="title-icon"
          src="https://pagina-otacc.s3.amazonaws.com/pages/otacc-page/assets/icons/title-icon-2.webp"
          alt=""
        />
      </div>
      <div className="info-infra-supercontainer">
        <div className="info-infra-container border-line">
          <div className="info-infra-txt-container">
            <p className="infra-subtitle">
              {t("infraestructure_page.info_section.list_info.title")}
            </p>
            <ul>
              <li>
                {t(
                  "infraestructure_page.info_section.list_info.list_elms.list_text_1"
                )}
              </li>
              <li>
                {t(
                  "infraestructure_page.info_section.list_info.list_elms.list_text_2"
                )}
              </li>

              <li>
                {t(
                  "infraestructure_page.info_section.list_info.list_elms.list_text_3"
                )}
              </li>

              <li>
                {t(
                  "infraestructure_page.info_section.list_info.list_elms.list_text_4"
                )}
              </li>

              <li>
                {t(
                  "infraestructure_page.info_section.list_info.list_elms.list_text_5"
                )}
              </li>

              <li>
                {t(
                  "infraestructure_page.info_section.list_info.list_elms.list_text_6"
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoInfraestructureSection;
